import { post } from "./_base";

let sendContactMessage = (data) => {
  return post("contact", data);
};

export { sendContactMessage };
